import {Box, Flex, Image, Text} from '@chakra-ui/react';
import {useTranslate} from '@eksab/i18n';
import {useIntl} from 'react-intl';
import crownImg from '../icons/crown.png';
import targetImg from '../icons/target.png';

type PlayHeaderProps = {
  scoreProps?: {
    score: number;
    noOfQuestions: number;
  };
};

export function PlayHeader(props: PlayHeaderProps) {
  const t = useTranslate();
  const formatNumber = useIntl().formatNumber;
  return (
    <Flex px="4" mb="2">
      <Flex
        flexDir="column"
        pos="relative"
        height="100%"
        alignItems="center"
        w={['full', null, 'fit-content']}
        px={props.scoreProps ? ['2', null, '24'] : '0'}
        mx={'auto'}
      >
        {/* Trivia Eksab */}
        <Box pos="relative">
          <Flex pos="relative" gap="2" px="16" py="4" alignItems="center" w="max-content">
            <TriviaEksabDecoration />
            <Image src={crownImg.src} w="8" h="8" alt="" />
            <Text fontSize="lg" lineHeight="27px" color="white" fontWeight="semibold">
              {t('app.trivia')}{' '}
              <Text as="span" fontSize="sm" color="#6D6D6D" fontWeight="normal">
                {t('app.name')}
              </Text>
            </Text>
          </Flex>
        </Box>
        {/* Score */}
        {!!props.scoreProps && (
          <>
            <Flex alignItems="center" mb={[10, null, '60px']} mt={['8', null, '9']} w="max-content" mx="auto">
              <Text fontSize="2xl" fontWeight="semibold" letterSpacing="tighter">
                {t('trivia.score')}
              </Text>
              <Box width="1px" bgColor="#ABABAB" h="2" ms={['1.5', null, '4']} me={['2', null, '6']} />
              <Flex gap="2" alignItems="center">
                <Image src={targetImg.src} alt="" h="9" w="9" />
                <Flex gap="1.5" alignItems="center">
                  <Text
                    fontSize="4xl"
                    fontWeight="bold"
                    color={props.scoreProps.noOfQuestions === props.scoreProps.noOfQuestions ? 'green.400' : 'black'}
                  >
                    {formatNumber(props.scoreProps.score)}
                  </Text>
                  <Text fontWeight="bold">/{formatNumber(props.scoreProps.noOfQuestions)}</Text>
                </Flex>
              </Flex>
            </Flex>
            <TriviaHeaderDecoration />
          </>
        )}
      </Flex>
    </Flex>
  );
}

const TriviaEksabDecoration = () => {
  return (
    <svg
      style={{position: 'absolute', inset: 0, zIndex: -1}}
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 272 65"
      fill="none"
    >
      <path
        d="M0 -1H272L249.346 35.1223C243.036 45.1827 232.583 51.9195 220.815 53.5096L141.133 64.2763C137.578 64.7566 133.975 64.7566 130.42 64.2763L50.8882 53.5299C39.0341 51.9281 28.5189 45.1053 22.2263 34.9323L0 -1Z"
        fill="#2A2E3A"
      />
    </svg>
  );
};

const TriviaHeaderDecoration = () => {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 471 202"
      fill="none"
      style={{position: 'absolute', inset: 0, zIndex: -2}}
    >
      <path
        d="M442.665 118.429L470.684 0.25H0.318455L29.2509 118.639C32.0233 129.984 40.4635 139.089 51.5656 142.712L225.055 199.329C231.843 201.544 239.159 201.549 245.95 199.344L420.249 142.743C431.452 139.105 439.948 129.89 442.665 118.429Z"
        fill="#FCFCFC"
        stroke="#B9B9B9"
        strokeWidth="0.5"
      />
    </svg>
  );
};
